import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useNavigate } from 'react-router';

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputBase, InputLabel, List, ListItem, ListItemText, MenuItem, Paper, Select, Typography } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';

import moment from 'moment';

import { openSnackbar } from '../store/slices/SnackbarSlice';

import { InputSearchButtonsStyle, InputSearchStyle } from '../styles/FormStyle';

import { DialogBuscarAudiencia } from './DialogBuscarAudiencia';

import { ObtenerMateria } from '../connections/catalogos/MateriaConnection';
import { CelebrarAudiencia } from '../connections/audiencias/AudienciaConnection';
import { BuscarExpediente } from '../connections/recepcion/ExpedienteConnection';
import { BuscarSecretariosAudiencias } from '../connections/admin/UsuarioConnection';
import { ObtenerAutoridadesMaterias } from '../connections/catalogos/AutoridadConnection';

import { MateriaProps } from '../interfaces/catalogos/MateriaInterface';
import { AutoridadProps } from '../interfaces/catalogos/AutoridadInterface';
import { UsuarioSecretarioProps } from '../interfaces/admin/UsuarioInterface';
import { AudienciaProgramadaProps, defaultAgendaProgramada } from '../interfaces/audiencias/AgendaInterface';
import { BuscarExpedienteResponse, defaultExpedienteResponse } from '../interfaces/recepcion/ExpedienteInterface';

interface Props {
    openDialog: boolean;
    handleCloseDialog: () => void;
}

export const DialogCelebrarAudiencia = ({ openDialog, handleCloseDialog }: Props) => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [loadingGuardar, setLoadingGuardar] = useState(false);

    const [openBuscarAgenda, setOpenBuscarAgenda] = useState(false);

    const [materia, setMateria] = useState(0);
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>([]);

    const [autoridad, setAutoridad] = useState(0);
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>([]);

    const [secretario, setSecretario] = useState(0);
    const [secretarioArray, setSecretarioArray] = useState<UsuarioSecretarioProps[]>([]);
    const [editandoSecretario, setEditandoSecretario] = useState(false);

    const [numeroExpediente, setNumeroExpediente] = useState('');
    const [expediente, setExpediente] = useState<BuscarExpedienteResponse>(defaultExpedienteResponse);

    const [audiencia, setAudiencia] = useState<AudienciaProgramadaProps>(defaultAgendaProgramada);

    const handleCelebrarAudiencia = async () => {

        setLoadingGuardar(true);

        await CelebrarAudiencia({ idAgenda: audiencia.id, idJuez: audiencia.idJuez, idSecretario: audiencia.idSecretario }).then( resp => {

            setTimeout(() => {

                const { message, success, idAudiencia } = resp

                if ( success ) {

                    setLoadingGuardar(false);

                    navigate(`gestionar-audiencia/celebrar-audiencia/${idAudiencia}`);
                        
                } 
                else {
                    
                    setLoadingGuardar(false);
                    dispatch(openSnackbar({ message, variant: 'error' }));
                        
                }
            
            }, 700);

        });

    }

    const handleBuscarExpediente = async () => {

        setLoading( true );

        await BuscarExpediente({ numeroExpediente, idAutoridad: autoridad }).then(resp => {

            const { success, message } = resp;

            if (success) {

                setTimeout(() => {

                    handleClear();
                    
                    setExpediente( resp );
                    setLoading( false );

                }, 700);

            }
            else {

                setTimeout(() => {

                    handleClear();
                    setLoading( false );

                    dispatch(openSnackbar({ message, variant: 'error' }));

                }, 700);

            }

        });

    }

    const handleClear = () => {

        setMateria( 0 );

        setAutoridad( 0 );
        setAutoridadArray( [] );

        setSecretario( 0 );
        setSecretarioArray( [] );
        setEditandoSecretario( false );

        setNumeroExpediente( '' );
        setExpediente( defaultExpedienteResponse );

        setAudiencia( defaultAgendaProgramada );

    }

    const handleCerrarDialog = () => {

        handleClear();
        handleCloseDialog();

    }

    const handleObtenerAgenda = ( row: AudienciaProgramadaProps ) => {

        setAudiencia( row );
        setSecretario( row.idSecretario );
        setEditandoSecretario( false );

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        if ( materia !== 0 ) {
            Obtener();
        }

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            setSecretario( 0 );
            setSecretarioArray( [] );

            await BuscarSecretariosAudiencias().then( resp => {
                setSecretarioArray( resp );
            });

        }

        if( expediente.idExpediente !== 0 ){
            Obtener();
        }

    }, [ expediente.idExpediente ]);

    return (
        <>

            <Dialog 
                maxWidth='md' 
                open={ openDialog } 
            >

                <DialogTitle>Celebrar audiencia</DialogTitle>

                <DialogContent>

                    <Grid container spacing={3} mt={1}>

                        <Grid size={{ md: 4, xs: 12 }}>

                            <FormControl required fullWidth>

                                <InputLabel>Materia</InputLabel>

                                <Select
                                    label="Materia"
                                    value={ materia }
                                    onChange={ (e) => setMateria( e.target.value ) }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>

                                    {
                                        materiaArray
                                        .filter( ({ idMateria }) => idMateria === 5 || idMateria === 6 )
                                        .map( ({ idMateria, descripcion  }) => (
                                            <MenuItem key={idMateria} value={idMateria}>{descripcion}</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 8, xs: 12 }}>

                            <FormControl required fullWidth>

                                <InputLabel>Autoridad</InputLabel>

                                <Select
                                    label="Autoridad"
                                    value={ autoridad }
                                    disabled={ materia === 0 }
                                    onChange={ (e) => setAutoridad( e.target.value ) }
                                >
                                    <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>

                                    {
                                        autoridadArray.map( ({ idAutoridad, descripcion }) => (
                                            <MenuItem key={idAutoridad} value={idAutoridad}>{descripcion}</MenuItem>
                                        ))
                                    }

                                </Select>

                            </FormControl>

                        </Grid>

                        <Grid size={{ md: 12, xs: 12 }}>

                            <Paper
                                component="div"
                                sx={ InputSearchStyle }
                            >

                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Buscar por número de expediente"
                                    value={ numeroExpediente }
                                    onChange={ (e) => setNumeroExpediente( e.target.value ) }
                                />

                                <Button
                                    type="button"
                                    variant='contained'
                                    size='small'
                                    sx={ InputSearchButtonsStyle }
                                    loading={ loading }
                                    disabled={ autoridad === 0 || numeroExpediente === '' }
                                    onClick={ handleBuscarExpediente }
                                >
                                    <SearchIcon />
                                </Button>

                            </Paper>

                        </Grid>

                        {
                            expediente.idExpediente !== 0
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Número de expediente: </Typography>}
                                                    secondary={
                                                        expediente.numeroFolio
                                                        ?
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } (F. { expediente.numeroFolio }) </Typography>
                                                        :
                                                            <Typography variant='subtitle2' fontWeight={'bold'}> { expediente.numeroExpediente } </Typography>
                                                    }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de juicio: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}> { expediente.tipoJuicio } </Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    {
                                        expediente.actores.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Actor(es): </Typography>}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                    {
                                                                        expediente.actores.map( (actor, index) => (
                                                                            <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}>{ actor }</Typography>
                                                                            </ListItem>
                                                                        ))
                                                                    }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }

                                    {
                                        expediente.demandados.length !== 0
                                        &&
                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <List disablePadding>

                                                    <ListItem sx={{ py: 0, px: 0 }}>

                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            slotProps={{ secondary: { component: 'div' } }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Demandado(s): </Typography>}
                                                            secondary={
                                                                <>
                                                                    <List disablePadding>
                                                                    {
                                                                        expediente.demandados.map( (demandado, index) => (
                                                                            <ListItem key={index} sx={{ py: 0, px: 0 }}>
                                                                                <Typography sx={{ color: 'black' }} variant='subtitle2' fontWeight={'bold'}>{ demandado }</Typography>
                                                                            </ListItem>
                                                                        ))
                                                                    }
                                                                    </List>
                                                                </>
                                                            }
                                                        />

                                                    </ListItem>

                                                </List>

                                            </Grid>
                                    }                                

                                </>
                        }

                        <Grid size={{ xs: 12, md: 12 }}>

                            <Paper
                                component="div"
                                sx={ InputSearchStyle }
                            >

                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Buscar audiencia"
                                    value={ '' }
                                    onChange={ () => {} }
                                />

                                <Button
                                    type="button"
                                    variant='contained'
                                    size='small'
                                    sx={ InputSearchButtonsStyle }
                                    onClick={ () => setOpenBuscarAgenda( true ) }
                                    disabled={ expediente.idExpediente === 0 }
                                >
                                    <SearchIcon />
                                </Button>

                            </Paper>

                        </Grid>

                        {
                            audiencia?.id !== 0
                            &&
                                <>

                                    <Grid size={{ md: 6, xs: 12 }}>
                                        
                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Tipo de audiencia: </Typography>}
                                                    secondary={<Typography variant='subtitle2' fontWeight={'bold'}>{ audiencia.tipoAudiencia }</Typography>}
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Fecha programada: </Typography>}
                                                    secondary={
                                                        <Typography variant='subtitle2' fontWeight={'bold'}>

                                                            { 
                                                                audiencia.fechaInicio 
                                                                &&
                                                                    <>
                                                                        <span>{ moment( audiencia.fechaInicio ).format('DD-MM-YYYY') }</span>

                                                                        <span style={{ margin: '0 2px' }}> </span>

                                                                        <span>{ moment( audiencia.fechaInicio ).format('HH:mm') }</span>

                                                                        <span style={{ margin: '0 2px' }}>-</span>
                                                                        
                                                                        <span>{ audiencia.fechaFin ? moment( audiencia.fechaFin ).format('HH:mm') : '' }</span>
                                                                    </>
                                                            }

                                                        </Typography>
                                                    }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>

                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem sx={{ py: 0, px: 0 }}>

                                                <ListItemText
                                                    sx={{ mr: 2 }}
                                                    primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Juez(a): </Typography>}
                                                    secondary={
                                                        <Typography variant='subtitle2' fontWeight={'bold'}>
                                                            { audiencia.juez }
                                                        </Typography>
                                                    }
                                                />

                                            </ListItem>

                                        </List>

                                    </Grid>
                                   
                                    <Grid size={{ md: 6, xs: 12 }}>

                                        <List disablePadding>

                                            <ListItem
                                                sx={{ py: 0, pl: 0, pr: editandoSecretario ? 7 : 5 }}
                                                secondaryAction={
                                                    editandoSecretario
                                                    ?
                                                        <IconButton
                                                            edge='end'
                                                            color='primary'
                                                            onClick={ () => setEditandoSecretario( false ) }
                                                        >
                                                            <CloseIcon fontSize='small' />
                                                        </IconButton>
                                                    :
                                                        <IconButton
                                                            edge='end'
                                                            color='primary'
                                                            size='small'
                                                            onClick={ () => setEditandoSecretario( true ) }
                                                        >
                                                            <EditIcon fontSize='small' />
                                                        </IconButton>
                                                }
                                            >

                                                {
                                                    editandoSecretario
                                                    ?
                                                        <FormControl fullWidth>

                                                            <InputLabel>Secretario(a) de audiencias</InputLabel>

                                                            <Select
                                                                label="Secretario(a) de audiencias"
                                                                value={ secretario }
                                                                onChange={ (e) => {

                                                                    const idSecretario = e.target.value as number;
                                                                    const seleccionado = secretarioArray.find( ({ id }) => id === idSecretario );

                                                                    setSecretario( idSecretario );
                                                                    setAudiencia({ ...audiencia, idSecretario, secretario: seleccionado ? seleccionado.nombreCompleto : '' });
                                                                    setEditandoSecretario( false );

                                                                } }
                                                            >
                                                                <MenuItem key={0} value={0}>Selecciona una opción</MenuItem>
                                                                {
                                                                    secretarioArray.map( ({ id, nombreCompleto }) => (
                                                                        <MenuItem key={id} value={id}>{nombreCompleto}</MenuItem>
                                                                    ))
                                                                }

                                                            </Select>

                                                        </FormControl>
                                                    :
                                                        <ListItemText
                                                            sx={{ mr: 2 }}
                                                            primary={<Typography variant='subtitle2' sx={{ color: 'text.secondary' }}> Secretario(a) de audiencia: </Typography>}
                                                            secondary={
                                                                <Typography variant='subtitle2' fontWeight={'bold'}>
                                                                    { audiencia.secretario }
                                                                </Typography>
                                                            }
                                                        />
                                                }

                                            </ListItem>

                                        </List>

                                    </Grid>

                                </>
                        }

                    </Grid>

                </DialogContent>

                <DialogActions>

                    <Button color='secondary' disabled={ loadingGuardar } onClick={ handleCerrarDialog }>Cancelar</Button>
                    <Button
                        variant="contained"
                        loading={ loadingGuardar }
                        onClick={ handleCelebrarAudiencia }
                        disabled={ expediente.idExpediente === 0 || audiencia.id === 0 || secretario === 0 }
                    >
                        Guardar
                    </Button>

                </DialogActions>

                <DialogBuscarAudiencia
                    idExpediente={ expediente.idExpediente }
                    open={ openBuscarAgenda }
                    setOpen={ setOpenBuscarAgenda }
                    obtenerAgenda={ handleObtenerAgenda }
                />

            </Dialog>

        </>
    )
}